module.exports = __webpack_public_path__ + "assets/img/school_text.46b798e4.png";